var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"w-full py-8 lg:px-20 px-4"})
}
var staticRenderFns = []

export { render, staticRenderFns }